import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from "react-router-dom";
import './nav-bar.scss'

export default function NavBar({ variant = 'light' }) {
  const site = process.env.REACT_APP_SITE || 'https://app.signetrisk.com';
  const isDark = variant === 'dark';
  const handleLoginClick = (e) => {
    e.preventDefault();
    window.location.href=`${site}/login`;
  };

  return(
    <Navbar
      expand="md"
      bg={isDark ? undefined : 'light'}
      variant={isDark ? 'dark' : 'light'}
      className={`site-navbar ${isDark ? 'is-dark' : 'is-light'}`}
      style={isDark ? undefined : { position: 'relative', zIndex: 2 }}
    >
      <Container style={{padding: '10px 0px',}}>
        <Link to="/" style={{textDecoration: 'none'}}>
          <Navbar.Brand style={{display: 'flex', padding: '15px 0px'}}>
              <img
                alt="SignetRisk"
                src={isDark ? "assets/logo-color-4.png" : "assets/logo-color-3.png"}
                style={{ height: '40px'}}
              />
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle className="navbar-toggler" type="button" aria-controls="basic-navbar-nav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse className="collapse navbar-collapse" id="basic-navbar-nav">
          <Nav className="navbar-nav me-auto mb-2 mb-md-0 site-navbar__links" style={{padding: '10px 0px', margin: 'auto'}}>
            <Link className="nav-route" to="/solutions">Solutions</Link>
            <Link className="nav-route" to="/pricing">Pricing</Link>
            <Link className="nav-route" to="/faq">FAQ</Link>
            <Link className="nav-route" to="/integrations">Integrations</Link>
            <Link className="nav-route" to="/about">About</Link>
          </Nav>
          <form className="d-flex">
            <button onClick={handleLoginClick} className="btn btn-link site-navbar__login" style={{marginRight: '5px'}}>Login</button>
            <Link to="/pricing" className="btn btn-secondary">Signup</Link>
          </form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
